import type { SVGProps } from "react";
export default function SvgChevronRight(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-chevron-right-icon lucide-chevron-right"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="m9 18 6-6-6-6" />
		</svg>
	);
}
